import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import GetVarBillingUsageDetailsQuery from '@/graphql/contracts//getVarBillingUsageDetails.query.gql';
import { GetVarBillingUsageDetails, GetVarBillingUsageDetailsVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageDetails.query';
import { UsageDetailsPayload } from '../../types';
import { USAGE_RECORDS_PER_PAGE } from '@/config/common.config';
import { encodePaginationPageToBase64 } from '../helpers/getUsageDetailsHelpers';
import { VarBillingUsageDetailOutput } from '@/graphql/contracts/_generated_/contracts';

export default function useGetVarBillingUsageDetails() {
  const [_getVarBillingUsageDetails, { loading, error, data, called }] =
    useLazyQuery<GetVarBillingUsageDetails, GetVarBillingUsageDetailsVariables>(GetVarBillingUsageDetailsQuery, {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    });

  const getVarBillingUsageDetails = (dto?: UsageDetailsPayload) => {
    return _getVarBillingUsageDetails({
      variables: {
        ...dto,
        first: dto?.first ?? USAGE_RECORDS_PER_PAGE,
        after: dto?.after ? encodePaginationPageToBase64(dto.after) : undefined
      },
    });
  };

  return {
    getVarBillingUsageDetails,
    varBillingUsageDetails: data?.paginatedFilteredVarBillingUsageDetails?.items as VarBillingUsageDetailOutput[]
      ?? [],
    isLoadingUsageDetails: loading,
    errorUsageDetails: error,
    isCalledUsageDetails: called
  } as const;
}
